"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.People = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var People = function People(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.182 9.423c-2.263 0-5.818 1.454-5.818 2.909v1.454H16v-1.454c0-1.455-3.556-2.91-5.818-2.91zm0-1.455a2.905 2.905 0 002.909-2.909c0-1.61-1.3-2.91-2.91-2.91-1.609 0-2.908 1.3-2.908 2.91s1.3 2.91 2.909 2.91zM4.727 2.877c.54 0 1.036.18 1.434.483a4.358 4.358 0 00-.343 1.699c0 .707.167 1.374.465 1.963-.416.363-.96.582-1.556.582a2.36 2.36 0 01-2.363-2.363 2.36 2.36 0 012.363-2.364zm0 5.909c.422 0 .899.076 1.383.204-.115.053-.227.107-.336.162-.656.328-1.289.722-1.783 1.158a3.873 3.873 0 00-.69.781c-.192.295-.392.722-.392 1.24H0V11.15c0-1.364 2.889-2.364 4.727-2.364z",
    fill: "currentColor"
  }));
};

exports.People = People;
var _default = People;
exports.default = _default;